import React from 'react';
import { Modal as AntdModal } from 'antd';
import styles from './index.module.scss';

const Modal = ({
  open,
  handleCancel = () => {},
  handleOk = () => {},
  ModalBody,
  title,
  width = 1000,
  modalStyles,
  showActions = false,
  okText = 'Submit',
  cancelText = 'Cancel',
  closable = true,
  showCustomFooter = false,
  customFooter = [],
  destroyOnClose = false,
  bodyAsFunction = false,
  okButtonProps = {},
  maskClosable = true,
  bodyStyle = {},
  closeByKeyboard = true,
  zIndex,
  cancelButtonProps = {},
}) => {
  return (
    <AntdModal
      title={title}
      open={open}
      zIndex={zIndex}
      onOk={handleOk}
      closable={closable}
      keyboard={closeByKeyboard}
      centered
      maskClosable={maskClosable}
      width={width}
      onCancel={(event) => {
        event.stopPropagation();
        handleCancel();
      }}
      {...(!showActions && !showCustomFooter
        ? { footer: null }
        : showCustomFooter && !showActions && { footer: customFooter })}
      style={modalStyles}
      styles={{
        body: bodyStyle,
      }}
      okText={okText}
      cancelText={cancelText}
      destroyOnClose={destroyOnClose}
      okButtonProps={{ ...okButtonProps, size: 'default' }}
      cancelButtonProps={{ ...cancelButtonProps, size: 'default' }}
      rootClassName={styles.modalWrap}
    >
      {bodyAsFunction ? <ModalBody /> : ModalBody}
    </AntdModal>
  );
};

export default Modal;
